var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from '@springcare/sh-component-library';
import { Card, Icon, IconButton, Link, Text } from 'shared/components';
import { ChevronRightSmall, CloseSmall } from 'shared/assets/icons';
import { useEffect, useState } from 'react';
export var StatusCard = function (_a) {
    var statusText = _a.statusText, statusTextColor = _a.statusTextColor, bgColor = _a.bgColor, icon = _a.icon, onClickCta = _a.onClickCta, clickedState = _a.clickedState;
    var _b = useState(clickedState), isClicked = _b[0], setIsClicked = _b[1];
    useEffect(function () {
        setIsClicked(clickedState);
    }, [clickedState]);
    return (_jsx(Card, __assign({ "data-testid": "sud_status_card", border: 'none', borderRadius: 8, bg: bgColor, color: statusTextColor, py: 2, px: 3, mb: 3, w: 'fit-content', cursor: onClickCta ? 'pointer' : 'default', onClick: function () {
            setIsClicked(!isClicked);
            if (onClickCta) {
                onClickCta();
            }
        } }, { children: _jsxs(Flex, __assign({ flexDir: 'row' }, { children: [_jsx(Icon, { as: icon, mr: 3, boxSize: 4 }), _jsx(Text, __assign({ fontWeight: 600, fontSize: 16 }, { children: statusText })), onClickCta &&
                    _jsxs(_Fragment, { children: [_jsx(Link, __assign({ ms: 3, fontWeight: 600, fontSize: 16, onClick: onClickCta, color: statusTextColor, _hover: {
                                    color: statusTextColor,
                                    textDecoration: 'underline',
                                } }, { children: "Learn More" })), _jsx(IconButton, { "aria-label": 'Learn More', ms: 3, my: 0, icon: isClicked ?
                                    _jsx(Icon, { width: 4, height: 4, color: 'white', as: CloseSmall }) :
                                    _jsx(Icon, { width: 4, height: 4, color: 'black', as: ChevronRightSmall }), width: 4, height: 4, minW: 0, border: '1px solid border-interactive', borderRadius: 'full', bg: isClicked ? 'content-secondary' : 'white', transition: '200ms', onClick: function () {
                                    setIsClicked(!isClicked);
                                    onClickCta();
                                }, _hover: {
                                    background: 'content-secondary',
                                } })] })] })) })));
};
